import React from "react";
import { Checkbox } from "antd";
import ConfigProvider from "./ConfigProvider";
import useDefaultTrebbleAntDTokenConfig from "../helper/useDefaultTrebbleAntDTokenConfig";
import PropTypes from "prop-types";

// Define prop types first
const checkboxPropTypes = {
  useEditorTheme: PropTypes.bool
};

const TrebbleCheckbox = ({ useEditorTheme, ...restProps }) => {
  const themeConfig = useDefaultTrebbleAntDTokenConfig({ useEditorTheme });

  return (
    <ConfigProvider theme={themeConfig}>
      <Checkbox {...restProps} />
    </ConfigProvider>
  );
};

const TrebbleCheckboxGroup = ({ useEditorTheme, ...restProps }) => {
  const themeConfig = useDefaultTrebbleAntDTokenConfig({ useEditorTheme });

  return (
    <ConfigProvider theme={themeConfig}>
      <Checkbox.Group {...restProps} />
    </ConfigProvider>
  );
};

// Set display names
TrebbleCheckbox.displayName = 'TrebbleCheckbox';
TrebbleCheckboxGroup.displayName = 'TrebbleCheckbox.Group';

// Set prop types
TrebbleCheckbox.propTypes = checkboxPropTypes;
TrebbleCheckboxGroup.propTypes = checkboxPropTypes;

// Add Group property to TrebbleCheckbox
TrebbleCheckbox.Group = TrebbleCheckboxGroup;

export default TrebbleCheckbox; 